import { render } from "./registerLocationDelegate.vue?vue&type=template&id=229b031c"
import script from "./registerLocationDelegate.vue?vue&type=script&lang=js"
export * from "./registerLocationDelegate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__